import {
  ContentSkeleton,
  PageContent,
  StatusPanel,
  type StatusPanelProps,
} from '@miniapp-core/ui-kit';
import type { MainMiniappRoute } from '@miniapp-core/components';
import RootMiniappShell from './RootMiniappShell';

type RouteStatusKind = 'loading' | 'redirect' | 'error' | 'unavailable';

interface RouteStatusContentProps {
  kind: RouteStatusKind;
  title: string;
  description?: string;
  action?: StatusPanelProps['action'];
}

const statusTone: Record<RouteStatusKind, NonNullable<StatusPanelProps['tone']>> = {
  loading: 'loading',
  redirect: 'loading',
  error: 'error',
  unavailable: 'info',
};

export function RouteStatusContent({ kind, title, description, action }: RouteStatusContentProps) {
  const showSkeleton = kind === 'loading';

  return (
    <PageContent
      spacing="relaxed"
      className="min-h-[calc(100dvh-var(--miniapp-overlay-offset,0px))] content-center"
    >
      <div className="mx-auto grid w-full max-w-lg gap-5">
        <StatusPanel
          title={title}
          tone={statusTone[kind]}
          {...(description ? { description } : {})}
          {...(action ? { action } : {})}
        />
        {showSkeleton ? <ContentSkeleton rows={3} /> : null}
      </div>
    </PageContent>
  );
}

interface RouteStatusScreenProps extends RouteStatusContentProps {
  activeRoute?: MainMiniappRoute;
  hasMiniPlayer?: boolean;
}

export default function RouteStatusScreen({
  activeRoute,
  hasMiniPlayer = false,
  ...statusProps
}: RouteStatusScreenProps) {
  return (
    <RootMiniappShell activeRoute={activeRoute} hasMiniPlayer={hasMiniPlayer}>
      <RouteStatusContent {...statusProps} />
    </RootMiniappShell>
  );
}
